// #586 (Björn): zentraler Bereich „Schreiben“ in der Seitenleiste – Neues Schreiben, Druckstapel, Verlauf aller
// Schreiben mit „Fortsetzen“, Wege zu Vorlagen und Serienmail. Ohne Umweg über ein Objekt.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Copy, EnvelopeSimple, PaperPlaneTilt } from '@phosphor-icons/react';
import { PostLogo } from '../../../components/epost/PostLogo';
import { ImmoButton } from '../../../components/immobilien/ui';
import { useMobilModus } from '../../../lib/immobilien/mobil';
import { Druckstapel } from './Druckstapel';
import { SchreibenLaeufe } from './SchreibenLaeufe';

export default function SchreibenUebersicht() {
  const navigate = useNavigate();
  const { mobil } = useMobilModus();
  const karte: React.CSSProperties = { borderRadius: 24, padding: mobil ? 14 : 18, gap: 12 };
  const titel: React.CSSProperties = { fontSize: 12, fontWeight: 800, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--ink3)' };
  const datum = new Date().toLocaleDateString('de-DE', { weekday: 'long', day: 'numeric', month: 'long' });
  const nebenKnopf: React.CSSProperties = { boxShadow: 'inset 0 0 0 1px var(--line)', fontWeight: 600 };

  return (
    <div className="flex flex-col min-w-0" style={{ gap: 16 }}>
      <header className="flex items-end justify-between flex-wrap" style={{ gap: 14 }}>
        <div className="flex flex-col min-w-0" style={{ gap: 2 }}>
          <span style={{ fontSize: 12, fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--ink3)' }}>{datum}</span>
          <h1 className="m-0" style={{ fontSize: mobil ? 30 : 40, fontWeight: 800, letterSpacing: '-0.035em', lineHeight: 1.05 }}>Schreiben</h1>
          <span style={{ fontSize: 14, color: 'var(--ink2)' }}>Briefe und Schreiben per E-Mail, Post, Portal oder Druck – an einen, mehrere oder alle Mieter bzw. Eigentümer eines Objekts</span>
        </div>
        <div className="flex flex-wrap" style={{ gap: 8 }}>
          <ImmoButton groesse={44} icon={Copy} onClick={() => navigate('/admin/dokumente?tab=vorl')} style={nebenKnopf}>Vorlagen</ImmoButton>
          <ImmoButton groesse={44} icon={PostLogo} onClick={() => navigate('/admin/dokumente?tab=post')} style={nebenKnopf}>Postausgang</ImmoButton>
          <ImmoButton art="akzent" groesse={44} icon={PaperPlaneTilt} onClick={() => navigate('/admin/schreiben/neu')}>Neues Schreiben</ImmoButton>
        </div>
      </header>

      <Druckstapel karte={karte} titel={titel} />

      <section className="immo-glas flex flex-col min-w-0" style={karte} aria-label="Verschickte Schreiben">
        <span style={titel}>Verschickte Schreiben</span>
        <SchreibenLaeufe />
      </section>

      <section className="immo-glas flex flex-wrap items-center min-w-0" style={{ ...karte, gap: 10 }} aria-label="Rundschreiben">
        <EnvelopeSimple size={20} color="var(--ink2)" />
        <span className="min-w-0 flex-1" style={{ fontSize: 13, color: 'var(--ink2)' }}>
          Rundschreiben an sehr viele Empfänger (über 100, z. B. alle Mieter aller Objekte) gehen über die Serienmail – per E-Mail und als Serienbrief per Post.
        </span>
        <ImmoButton groesse={36} onClick={() => navigate('/admin/serienmail')}>Zur Serienmail</ImmoButton>
      </section>
    </div>
  );
}
